// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__3zR1W","normal":"Index_normal__2ciAC","normalh5":"Index_normalh5__1Ghif","animationFade":"Index_animationFade__2Mw7C"};